import {fadeOutEffect, fadeInEffect} from './serie-effects.js';
import Swiper, { Navigation, Pagination, Lazy, Autoplay, startAutoplay, Grid } from 'swiper';

Swiper.use([Navigation, Pagination, Lazy, Autoplay, startAutoplay, Grid]);

let isMobile = false;
let header = document.querySelector('header.header');
let headerDesktop = header.querySelector('.header__desktop');
let headerMobile = header.querySelector('.header__mobile');

if(window.screen.width >= 1023){
    isMobile = false;
} else {
    isMobile = true;
}

const headerFunctions = {
    /**
     * Abre e fecha a modal de login
    */
    showAndHideLoginModal: function(){
        let login = headerDesktop.querySelector('.client__login .login__icon');
        let modal = headerDesktop.querySelector('.client__login .login__modal');
        let buttonClose = headerDesktop.querySelector('.client__login .login__modal');

        login.addEventListener('click', ( event ) => {
            let _this = event.currentTarget;

            if( _this.classList.contains('active') ){
                fadeOutEffect( modal );

                _this.classList.remove('active');

            } else {
                fadeInEffect( modal );

                _this.classList.add('active');
            }
        });

        buttonClose.addEventListener('click', () => {
            fadeOutEffect( modal );

            login.classList.remove('active');
        });

        window.addEventListener('scroll', () => {
            fadeOutEffect( modal );

            login.classList.remove('active');
        });
    },

    /**
     * Abre e fecha o campo de busca na versão mobile
    */
    showAndHideSearchField: function(){
        let form = headerMobile.querySelector('.header__client .client__search form');
        let button = headerMobile.querySelector('.header__client .search__icon');

        button.addEventListener('click', ( event ) => {
            let _this = event.currentTarget;

            if( _this.classList.contains('active') ){
                fadeOutEffect( form );

                _this.classList.remove('active');

            } else {
                fadeInEffect( form );

                _this.classList.add('active');
            }
        });
    },

    /**
     * Abre e fecha o menu do header na versão mobile
    */
    showAndHideHeaderMenu: function(){
        let menu = headerMobile.querySelector('.header__menu');
        let buttonOpen = headerMobile.querySelector('.header__tabs .tabs__inner');
        let buttonClose = headerMobile.querySelector('.header__menu .menu__top .menu__close');
        let duration = 500;

        buttonOpen.addEventListener('click', () => {
            menu.style.left = 0;
            menu.style.transitionDuration = duration + 'ms';
        });

        buttonClose.addEventListener('click', () => {
            menu.style.left = '-100%';
            menu.style.transitionDuration = duration + 'ms';
        });
    },

    /**
     * Abre e fecha o submenu clicado do header na versão mobile
    */
    showAndHideHeaderSubmenu: function(){
        let menu = headerMobile.querySelector('.header__menu');
        let menuHasSubmenu = Array.from( headerMobile.querySelectorAll('.header__menu .menu__inner > ul > li.has-submenu') );
        let submenus = Array.from( headerMobile.querySelectorAll('.header__menu .menu__submenu') );
        let duration = 500;

        const closeMenu = ( element ) => {
            element.style.left = '-100%';
            element.style.transitionDuration = duration + 'ms';
        }

        if( menuHasSubmenu.length > 0 ){
            menuHasSubmenu.forEach(currentSubmenu => {
                let button = currentSubmenu.querySelector('.menu__button');

                if( button ){
                    button.addEventListener('click', ( event ) => {
                        let dataSubmenu = event.currentTarget.parentNode.getAttribute('data-menu');
                        
                        // Abre o submenu correspondente
                        headerMobile.querySelector(`.header__menu .menu__submenu[data-submenu="${dataSubmenu}"]`).style.left = '0%';
                        headerMobile.querySelector(`.header__menu .menu__submenu[data-submenu="${dataSubmenu}"]`).style.transitionDuration = duration + 'ms';

                        // Fecha o submenu ou o menu juntos depedendo do botão clicado
                        submenus.forEach(currentSubmenu => {
                            // Se clicar fechar o submenu e o menu juntos
                            currentSubmenu.querySelector('.submenu__title .close__submenu').addEventListener('click', ( event ) => {
                                closeMenu( currentSubmenu );

                                setTimeout(() =>{
                                    closeMenu( menu );
                                }, 500);
                            });

                            // Se clicar fecha somente o submenu
                            currentSubmenu.querySelector('.submenu__title .back__submenu').addEventListener('click', ( event ) => {
                                closeMenu( currentSubmenu );
                            });
                        });
                    });
                }
            });
        }
    },

    /**
     * Faz a montagem do carousel do topo do header
     */
    setRuler: () => {
        const message = document.querySelectorAll('[data-top-swiper]');

        message.forEach((section) => {
        const carousel = section.querySelector('.swiper');

            const swiper = new Swiper(carousel, {
                slidesPerView: 1,
                loop: true,
                speed: 5000,
                freeMode: true,
                autoplay: {
                    delay: 0
                },
                breakpoints: {
                    1024: {
                        speed: 7000,
                    }
                },
            });
        });
    },

    updateCartItems: function(){
        let target = headerDesktop.querySelector('.middle__client .client__cart');

        let observer = new MutationObserver(function(mutations){
            setTimeout(function(){
                let cartCount = headerDesktop.querySelector('span[data-cart-count]').textContent;

                headerMobile.querySelector('span[data-cart-count-mobile]').innerHTML = cartCount;
            }, 200);
        });
        
        let config = { attributes: true, childList: true, subtree: true, characterData: true };
        observer.observe(target, config);
    },

    init: function(){
        const _this = this;

        _this.setRuler();

        if( isMobile == false ){
            _this.showAndHideLoginModal();
        }

        if( isMobile == true ){
            _this.showAndHideSearchField();
            _this.showAndHideHeaderMenu();
            _this.showAndHideHeaderSubmenu();
            _this.updateCartItems();
        }
    },
}

export default headerFunctions;